import React from "react";
import styled from "styled-components";
import Icon from "components/common/Icon";
import Spinner from "components/common/Spinner";
const StepItem = styled.li`
  display: flex;
  margin: 0 0 12px;
`;
const IconWrap = styled.div`
  min-width: 36px;
`;
const Content = styled.div`
  flex-grow: 1;
`;
const StepHeader = styled.span`
  font-size: 18px;
`;
const StepDetails = styled.p`
  margin: 3px 0 0;
`;
const KinesisSetupStep = ({ label, progress }) => {
  const { data, error, loading } = progress;
  const waitingText = !data && !loading && !error && "Waiting...";
  const loadingText = loading ? `Creating ${label}` : waitingText;
  const successText = data ? data.result : loadingText;
  const defaultText = error || successText;
  return /* @__PURE__ */ React.createElement(StepItem, null, /* @__PURE__ */ React.createElement(IconWrap, null, !data && !loading && !error && /* @__PURE__ */ React.createElement(Icon, { name: "hourglass_bottom", size: "2x", style: { color: "#dce1e5" } }), loading && /* @__PURE__ */ React.createElement(Spinner, { size: "2x", style: { color: "#0063be" } }), data && /* @__PURE__ */ React.createElement(Icon, { name: "check", size: "2x", style: { color: "#00ae42" } }), error && /* @__PURE__ */ React.createElement(Icon, { name: "close", size: "2x", style: { color: "#ad0707" } })), /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(StepHeader, null, "Create ", label), /* @__PURE__ */ React.createElement(StepDetails, null, defaultText)));
};
export default KinesisSetupStep;
